import { SystemStyleObject } from '@chakra-ui/react';
import {
  CHAT_BAR_KEY,
  getMaxWidth,
  getMinWidth,
  getWidth,
} from 'app/utils/hooks';

export const getStyles = ({
  forceCompactMode,
  isDragging,
}: {
  forceCompactMode: boolean;
  isDragging: boolean;
}) => {
  const rootSx = {
    zIndex: 1,
    ml: 2,
    flexShrink: 0,
    position: 'relative',
    width: getWidth(CHAT_BAR_KEY),
    minW: getMinWidth(CHAT_BAR_KEY),
    maxW: getMaxWidth(CHAT_BAR_KEY),
  };

  const wrapperSx = {
    position: 'absolute',
    width: 'inherit',
    maxWidth: 'inherit',
  };

  const contentSx = {
    alignItems: 'baseline',
    width: 'inherit',
    gap: 1,
    overflow: 'hidden',
  };

  const cardSx = {
    w: 'full',
    pt: 6,
    pb: 4,
    px: 2,
    gap: 1,
    rounded: 6,
    flex: 1,
    overflow: 'hidden',
  };

  const sidebarResizeLineSx: SystemStyleObject = {
    position: 'absolute',
    left: 0,
    height: 'full',
    px: 0.5,
    zIndex: 1,
    '& div': {
      w: 0.5,
      h: 'full',
      bg: isDragging ? 'B.80' : 'none',
    },
    _hover: {
      '& div': {
        ...(!forceCompactMode ? { bg: 'B.80' } : {}),
      },
    },
  };

  const closeIconSx: SystemStyleObject = {
    h: 5,
    w: 5,
    minW: 5,
    color: 'iconBase',
    _hover: {
      color: 'textBase',
    },
  };

  return {
    rootSx,
    wrapperSx,
    contentSx,
    cardSx,
    sidebarResizeLineSx,
    closeIconSx,
  };
};
